import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[marker]',
})
export class MarkerInfoDirective {
  public constructor(public viewContainerRef: ViewContainerRef) {}
}
